<mat-toolbar class="topbar">
  <button *ngIf="layoutConf.sidebarStyle !== 'compact'" mat-icon-button id="sidenavToggle" (click)="toggleSidenav()"
    matTooltip="{{'TOGGLE_HIDE_OPEN' | translate}}">
    <mat-icon>menu</mat-icon>
  </button>

  <span fxFlex></span>
  <span class="fz-1" *ngIf="!layoutConf.isMobile">
    {{utils.truncate(empresaNomeSessao, 20)}}
  </span>
  <span class="fz-1" *ngIf="layoutConf.isMobile">
    {{utils.truncate(empresaNomeSessao, 12)}}
  </span>

  <div class="toolbar-actions">
    <!-- Language Switcher -->
    <button mat-button [matMenuTriggerFor]="menu" class="language-button">
      <span class="flag-icon {{currentLang.flag}} mr-05"></span>
      <span>{{currentLang.name}}</span>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item *ngFor="let lang of availableLangs" (click)="setLang(lang)">
        <span class="flag-icon mr-05 {{lang.flag}}"></span>
        <span>{{lang.name}}</span>
      </button>
    </mat-menu>

    <!-- Compromissos shortcut -->
    <button mat-icon-button matTooltip="Agenda de Compromissos" [routerLink]="['/utilitario/compromisso']"
      class="topbar-button-right">
      <mat-icon>event_note</mat-icon>
    </button>

    <!-- Notification toggle button -->
    <button mat-icon-button matTooltip="{{'NOTIFICATION' | translate}}" (click)="toggleNotificationPanel()"
      class="topbar-button-right">
      <mat-icon>notifications</mat-icon>
      <span class="notification-number mat-bg-warn" *ngIf="(notificPanel.totalNotif ?? 0) > 0">
        {{notificPanel.totalNotif}}
      </span>
    </button>

    <!-- User menu -->
    <button mat-icon-button [matMenuTriggerFor]="accountMenu" class="topbar-button-right profile-button">
      <img [appImageLoader]="jwtAuth.url + jwtAuth.path + '/image/profile'" alt="" class="profile-img mat-elevation-z1">
    </button>
    <mat-menu #accountMenu="matMenu">
      <button mat-menu-item [routerLink]="['/profile/account']">
        <mat-icon>account_box</mat-icon>
        <span>{{ "ACCOUNT" | translate }}</span>
      </button>
      <button mat-menu-item [routerLink]="['/profile/filial']">
        <mat-icon>swap_vertical_circle</mat-icon>
        <span>{{ "ENTERPRISE" | translate }}</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item [routerLink]="['/utilitario/compromisso']">
        <mat-icon>event_note</mat-icon>
        <span>Agenda de Compromissos</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="jwtAuth.signout()">
        <mat-icon>exit_to_app</mat-icon>
        <span>{{ "SIGNOUT" | translate }}</span>
      </button>
    </mat-menu>

    <!-- Apps menu -->
    <button mat-icon-button [matMenuTriggerFor]="appsMenu" class="topbar-button-right">
      <mat-icon>apps</mat-icon>
    </button>
    <mat-menu #appsMenu="matMenu">
      <button mat-menu-item matTooltip="Aplicativo Infokaw Força de Vendas"
        (click)="openExternalApp('https://infokaw.com.br/kawflex')" class="app-menu-item">
        <img src="assets/icons/ik-72x72.png" alt="Infokaw SF" class="menu-icon" *ngIf="!layoutConf.isMobile">
        <img src="assets/icons/ik-48x48.png" alt="Infokaw SF" class="menu-icon" *ngIf="layoutConf.isMobile">
      </button>
      <button mat-menu-item matTooltip="Emissor de NFe otimizado para dispositivos móveis"
        (click)="openExternalApp('https://infokaw.com.br/nfego')" class="app-menu-item">
        <img src="assets/icons/nfego-72x72.png" alt="NF-e Go" class="menu-icon" *ngIf="!layoutConf.isMobile">
        <img src="assets/icons/nfego-48x48.png" alt="NF-e Go" class="menu-icon" *ngIf="layoutConf.isMobile">
      </button>
      <button mat-menu-item matTooltip="360° de liberdade nas suas vendas app de vendas otimizado para dispositivos móveis"
        (click)="openExternalApp('https://infokaw.com.br/v360')" class="app-menu-item">
        <img src="assets/icons/V360-72x72.png" alt="V360" class="menu-icon" *ngIf="!layoutConf.isMobile">
        <img src="assets/icons/V360-48x48.png" alt="V360" class="menu-icon" *ngIf="layoutConf.isMobile">
      </button>
    </mat-menu>
  </div>
</mat-toolbar>
